import React, { memo } from "react";

// Static styles to avoid object recreation on renders
const thStyle = { width: "60px" };
const tdStyle = { width: "60px", paddingLeft: "24px" };

const HistoryTable = ({ activeTab, historyList }) => {
  // Determine column visibility once
  const isRcOrPermit = activeTab === "RC" || activeTab === "Permit";
  const isInsurance = activeTab === "Insurance";

  return (
    <div className="card rounded-4">
      <div className="table-responsive">
        <table className="table align-middle mb-0">
          <thead>
            <tr>
              <th className="fs-12 px-2 py-1 text-center" style={thStyle}>
                S.NO
              </th>
              {isRcOrPermit && <th>{activeTab} Number</th>}
              {isInsurance && <th>Name</th>}
              <th>Valid Till</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {historyList.map((item, i) => (
              <tr key={i}>
                <td className="fs-12 px-2 py-1 text-center" style={tdStyle}>
                  {i + 1}
                </td>
                {isRcOrPermit && <td>{item.document_number ?? "-"}</td>}
                {isInsurance && <td>{item.document_name ?? "-"}</td>}
                <td>{item.valid_till ?? "-"}</td>
                <td>{item.status ?? "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default memo(HistoryTable);
